import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "environments/environment";

export interface RegistroUsuarioDTO {
    nome: string;
    email: string;
    celular: string;
    cpf: string;
    senha: string;
    confirmarSenha: string;
    gclid?: string | null;
}

export interface RegistroRespostaDTO {
    sucesso: boolean;
    mensagem: string;
    usuarioId?: number;
}

export interface ValidarEmailDTO {
    email: string;
    codigo: string;
}

export interface RespostaPadraoDTO {
    sucesso: boolean;
    mensagem: string;
}

@Injectable({
    providedIn: 'root'
})
export class RegistroService {

    private readonly baseUrl = `${environment.urlApi}/registro`;

    constructor(private httpClient: HttpClient) { }

    criar(dto: RegistroUsuarioDTO): Promise<RegistroRespostaDTO> {
        return firstValueFrom(
            this.httpClient.post<RegistroRespostaDTO>(`${this.baseUrl}/criar`, dto)
        );
    }

    validarEmail(dto: ValidarEmailDTO) {
        return firstValueFrom(
            this.httpClient.post<any>(`${this.baseUrl}/validar-email`, dto)
        );
    }

    reenviarCodigo(email: string): Promise<RespostaPadraoDTO> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadraoDTO>(`${this.baseUrl}/reenviar-codigo`, { email })
        );
    }
}
